export default "__VITE_ASSET__cRiwe05l__"